module.exports = __webpack_public_path__ + "media/images/photo/plans/common/plan-original-proposal-ef1c789355e03c55aa58f35d51073338.png";